import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useKid } from "@/context/KidContext";
import { Link } from "react-router-dom";

export default function ParentsDashboard() {
  const { kids } = useKid();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/parents/dashboard").then(({ data }) => setData(data)).catch(() => {});
  }, [kids.length]);

  if (!data) return <div className="p-10 text-center text-[#243B53]/60">Carregando…</div>;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8" data-testid="parents-dashboard">
      <div className="flex items-center gap-3">
        <span className="text-3xl">👨‍👩‍👧</span>
        <div>
          <h1 className="text-3xl font-extrabold text-[#243B53]">Área dos Responsáveis</h1>
          <p className="text-[#243B53]/70 text-sm">Acompanhe a jornada de cada criança.</p>
        </div>
      </div>

      <p className="mt-2 text-xs text-[#243B53]/60" data-testid="parents-supervision-note">
        Os perfis infantis e suas atividades são gerenciados pelo responsável da conta.
      </p>

      <section
        className="mt-5 card-soft p-4 bg-[#FFF9ED] flex items-start gap-3"
        data-testid="healthy-use-section"
        aria-label="Uso saudável"
      >
        <span className="text-2xl">💛</span>
        <div>
          <div className="font-extrabold text-[#243B53]">Uso saudável</div>
          <p className="text-sm text-[#243B53]/75">
            O Clubinho da Fé recomenda que crianças utilizem a plataforma com acompanhamento
            de um responsável e com equilíbrio no tempo de tela.
          </p>
        </div>
      </section>

      {(data.children || []).length === 0 ? (
        <div className="mt-8 card-soft p-10 text-center">
          <div className="text-4xl">🧒</div>
          <div className="mt-3 font-bold text-[#243B53]">Cadastre sua primeira criança</div>
          <Link to="/profile" className="btn-primary inline-block mt-4">Ir para o perfil</Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {data.children.map((row) => (
            <div key={row.child.id} data-testid={`parents-kid-${row.child.id}`} className="card-soft p-6">
              <div className="flex items-center gap-3">
                <div className="w-14 h-14 rounded-full bg-[#FFD54F] flex items-center justify-center text-2xl">{row.child.avatar || "🧒"}</div>
                <div>
                  <div className="font-extrabold text-[#243B53] text-lg">{row.child.name}</div>
                  <div className="text-xs text-[#243B53]/60">Faixa {row.child.age_group || "-"}</div>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-4 gap-2 text-center">
                <MiniStat label="Pontos" value={row.points} />
                <MiniStat label="Estrelas" value={row.stars} />
                <MiniStat label="Streak" value={`${row.streak_days}d`} />
                <MiniStat label="Conquistas" value={row.achievements_count} />
              </div>
              <div className="mt-4 grid grid-cols-3 gap-2 text-center text-xs">
                <div className="card-soft !shadow-none border p-2"><b>{row.activities_completed}</b> atividades</div>
                <div className="card-soft !shadow-none border p-2"><b>{row.missions_completed}</b> missões</div>
                <div className="card-soft !shadow-none border p-2"><b>{row.journeys_completed}/{row.journeys_started}</b> jornadas</div>
              </div>
              <Link to="/passport" className="mt-4 btn-outline inline-block text-sm">Ver Passaporte</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function MiniStat({ label, value }) {
  return (
    <div className="bg-[#FFF9ED] rounded-xl py-2">
      <div className="font-extrabold text-[#243B53]">{value}</div>
      <div className="text-[10px] font-bold text-[#243B53]/60">{label}</div>
    </div>
  );
}
